import { render } from "./Example.vue?vue&type=template&id=69070706&scoped=true&ts=true"
import script from "./Example.vue?vue&type=script&lang=ts"
export * from "./Example.vue?vue&type=script&lang=ts"

import "./Example.vue?vue&type=style&index=0&id=69070706&lang=scss&scoped=true"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69070706"]])

export default __exports__